import { Injectable } from "@angular/core";
import { env } from "@env/environment";
import { Observable, throwError as observableThrowError } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import { TipologiaDocumentoDTO } from "../dto/tipologia-documentoDTO";
import { TipologiaDocumentoVO } from "../vo/tipologia-documentoVO";
import { MapperValoriDefaultDocumento } from "../mapper/mapper-valori-default-documento";
import { UnitaDocumentariaVO } from "../vo/unita-documentariaVO";
import { BaseResponseVO } from "../vo/base-responseVO";
import { BaseResponseDTO } from "../dto/base-responseDTO";
import { MapperUnitaDocumentaria } from "../mapper/mapper-unita-documentaria";
import { MapperBaseResponse } from "../mapper/mapper-baseresponse";
import { UnitaDocumentariaDTO } from "../dto/unita-documentariaDTO";
import { ModaleErroreStore } from "../store/modale-errore.store";
import { ModificaUdRequestDTO } from "../dto/modifica-ud-requestDTO";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { OrdinamentoVO } from "../vo/ordinamentoVO";
import { ResultListVO } from "../vo/resultList.vo";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperResultListUd } from "../mapper/mapper-resultList-Ud";
import { CaricaNuovaVersioneDocumentoRequestDTO } from "../dto/carica-nuova-versione-documento-requestDTO";
import { CaricaNuovaVersioneDocumentoRequestVO } from "../vo/carica-nuova-versione-documento-requestVO";
import { MapperCaricaNuovaVersioneDocumento } from "../mapper/mapper-carica-nuova-versione-documento";
import { DocumentoVO } from "../vo/documentoVO";
import { DocumentoDTO } from "../dto/documentoDTO";
import { MapperDocumento } from "../mapper/mapper-documento";
import { FascicoloVO } from "../vo/fascicoloVO";
import { FiltroRicercaUnitaDocumentariaDTO } from "../dto/filtro-ricerca-unita-documentariaDTO";
import { MapperFiltroRicercaUnitaDocumentaria } from "../mapper/mapper-filtro-ricerca-unita-documentaria";
import { FiltroRicercaUnitaDocumentariaVO } from "../vo/filtro-ricerca-unita-documentariaVO";
import { DatiReportorioDTO } from "../dto/dati-repertorioDTO";
import { MapperDatiRepertorio } from "../mapper/mapper-dati-repertorio";
import { DatiReportorioManualiVO } from "../vo/dati-repertorio-manualiVO";
import { MapperCalcolaDimensioniRequest } from "../mapper/mapper-calcola-dimensioni-request";
import { MapperCalcolaDimensioniResponse } from "../mapper/mapper-calcola-dimensioni-response";
import { CalcolaDimensioniResponseVO } from "../vo/calcola-dimensioni-responseVO";
import { CalcolaDimensioniResponseDTO } from "../dto/calcola-dimensioni-responseDTO";
import { CalcolaDimensioniRequestVO } from "../vo/calcola-dimensioni-requestVO";
import { TempiConservazioneDTO } from "../dto/tempi-conservazioneDTO";
import { AttivitaUnitaDocumentariaVO } from "../vo/attivita-unita-documentariaVO";
import { AttivitaUnitaDocumentariaDTO } from "../dto/attivita-unita-documentariaDTO";
import { MapperResultListAttivitaUnitaDocumentaria } from "../mapper/mapper-resultList-attivita-unita-documentaria";
import { CompletaBozzaRequestDTO } from "../dto/completa-bozza-requestDTO";
import { MapperDatiRepertorioManuali } from "../mapper/mapper-dati-repertorio-manuali";
import { ResponseUploadFileVO } from "../vo/response-upload-fileVO";

@Injectable({
  providedIn: "root",
})
export class DocumentoService {
  constructor(
    private http: HttpClient,
    private mapperValoriDefaultDocumento: MapperValoriDefaultDocumento,
    private mapperUnitaDocumentaria: MapperUnitaDocumentaria,
    private mapperBaseResponse: MapperBaseResponse,
    private modaleErroreStore: ModaleErroreStore,
    private mapperResultListUd: MapperResultListUd,
    private mapperDocumento: MapperDocumento,
    private mapperCaricaNuovaVersioneDocumento: MapperCaricaNuovaVersioneDocumento,
    private mapperFiltroRicercaUnitaDocumentaria: MapperFiltroRicercaUnitaDocumentaria,
    private mapperDatiRepertorio: MapperDatiRepertorioManuali,
    private mapperDatiRepertorioManuali: MapperDatiRepertorioManuali,

    private mapperCalcolaDimensioniRequest: MapperCalcolaDimensioniRequest,
    private mapperResultListAttivitaUd: MapperResultListAttivitaUnitaDocumentaria,
    private mapperCalcolaDimensioniResponse: MapperCalcolaDimensioniResponse
  ) { }

  private urlTipologiaDocumento =
    env.LINNEO_API_URL_BASE + env.LINNEO_RICERCA_TIPOLOGIA_DOCUMENTO;
  private urlUnitaDocumentaria =
    env.DOCUMENTALE_API_URL_BASE +
    // "http://localhost:9092" +
    env.URL_UNITA_DOCUMENTARIA;
  private urlCalcolaDimensioneDocumento =
    env.API_URL_BASE + env.URL_CALCOLA_DIMENSIONE_DOCUMENTI;
  private urlDocumento = env.DOCUMENTALE_API_URL_BASE + env.URL_DOCUMENTO;
  private urlUpload = env.DOCUMENTALE_API_URL_BASE + env.URL_UPLOAD;


  creaUnitaDocumentaria(
    unitaDocumentaria: UnitaDocumentariaVO
  ): Observable<BaseResponseVO> {
    return this.http
      .post<BaseResponseDTO>(
        this.urlUnitaDocumentaria,
        this.mapperUnitaDocumentaria.convertVoToDto(unitaDocumentaria)
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        )
      );
  }
  ricercaUnitaDocumentarie(
    filtro: FiltroRicercaUnitaDocumentariaVO,
    paginazione: PaginazioneVO,
    ordinamento: OrdinamentoVO
  ): Observable<ResultListVO<UnitaDocumentariaVO>> {
    const url = this.urlUnitaDocumentaria + "ricerca";
    let ordinamentoVO: OrdinamentoVO = new OrdinamentoVO();
    if (ordinamento == null) {
      ordinamentoVO.elemento = "classifica.codice";
      ordinamentoVO.direzione = 0;
    } else {
      ordinamentoVO = ordinamento;
    }

    const params = new HttpParams()
      .set("pageElement", paginazione.size.toString())
      .set("pageNumber", paginazione.pageNumber.toString())
      .set("orderBy", ordinamentoVO.elemento.toString())
      .set("desc", ordinamentoVO.direzione.toString());
    console.log(
      "[DocumentoServiceComponent][ricercaUnitaDocumentarie] url",
      url
    );
    console.log(
      "[DocumentoServiceComponent][ricercaUnitaDocumentarie] filtro",
      filtro
    );
    console.log(
      "[DocumentoServiceComponent][ricercaUnitaDocumentarie] params",
      params
    );
    const filtroDTO: FiltroRicercaUnitaDocumentariaDTO = this.mapperFiltroRicercaUnitaDocumentaria.convertVoToDto(
      filtro
    );
    return this.http.post(url, filtroDTO, { params: params }).map(
      (resultList: ResultListDTO<UnitaDocumentariaDTO>) =>
        this.mapperResultListUd.convertDtoToVo(resultList) // creare result list e filtro
    );
  }

  uploadDocumento(
    data: FormData,
  ): Observable<ResponseUploadFileVO> {

    return this.http
      .post<ResponseUploadFileVO>(
        this.urlUpload,
        data
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: ResponseUploadFileVO) =>
          response
        )
      );
  }

  caricaNuovaVersioneDocumento(
    id: string,
    nuovaVersioneDocumento: CaricaNuovaVersioneDocumentoRequestVO
  ): Observable<BaseResponseVO> {
    return this.http
      .post<BaseResponseDTO>(
        this.urlUnitaDocumentaria + id + "/nuova-versione-documento",
        this.mapperCaricaNuovaVersioneDocumento.convertVoToDto(
          nuovaVersioneDocumento
        )
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        )
      );
  }

  ripristinaVersioneDocumento(
    id: string,
    nuovaVersioneDocumento: CaricaNuovaVersioneDocumentoRequestVO
  ): Observable<BaseResponseVO> {
    return this.http
      .post<BaseResponseDTO>(
        this.urlUnitaDocumentaria + id + "/ripristina-versione-documento",
        this.mapperCaricaNuovaVersioneDocumento.convertVoToDto(
          nuovaVersioneDocumento
        )
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        )
      );
  }

  getTipologiaDocumento(nome: String): Observable<TipologiaDocumentoVO[]> {
    console.log(
      "[DocumentoServiceComponent][getTipologiaDocumento] URL Tipologia documento",
      this.urlTipologiaDocumento
    );
    console.log(
      "[DocumentoServiceComponent][getTipologiaDocumento] URL BASE",
      env.API_URL_BASE
    );
    console.log(
      "[DocumentoServiceComponent][getTipologiaDocumento] chiave",
      nome
    );
    return this.http.get(this.urlTipologiaDocumento + nome).pipe(
      map((response: TipologiaDocumentoDTO[]) =>
        this.convertDataTipologiaDocumento(response)
      ),
      catchError((_) => Observable.of([]))
    );
  }

  convertDataTipologiaDocumento(tipologiaDocumento: TipologiaDocumentoDTO[]) {
    //       let struttureDTO: StrutturaDTO[];
    let tipologieDocumento: TipologiaDocumentoVO[];
    console.log(
      "[DocumentoServiceComponent][convertDataTipologiaDocumento]numero risultati: " +
      tipologiaDocumento.length
    );
    tipologieDocumento = new Array<TipologiaDocumentoVO>();
    tipologiaDocumento.forEach((element) => {
      const tipologiaDocumentoVO = new TipologiaDocumentoVO();
      tipologiaDocumentoVO.id = element.id;
      tipologiaDocumentoVO.dataManuale = element.dataManuale;
      tipologiaDocumentoVO.codice = element.codice;
      tipologiaDocumentoVO.nome = element.nome;
      tipologiaDocumentoVO.descrizione = element.descrizione;
      tipologiaDocumentoVO.valoriDefaultDocumento = this.mapperValoriDefaultDocumento.convertDtoToVo(
        element.valoriDefaultDocumento
      );
      tipologiaDocumentoVO.output = element.nome + " - " + element.descrizione;
      tipologieDocumento.push(tipologiaDocumentoVO);
    });
    console.log(
      "[DocumentoServiceComponent][convertDataTipologiaDocumento]tipologie doc",
      tipologieDocumento
    );
    return tipologieDocumento;
  }

  getUnitaDocumentaria(id: string): Observable<UnitaDocumentariaVO> {
    const url = this.urlUnitaDocumentaria + id;
    console.log("[DocumentoServiceComponent][getUnitaDocumentaria] url: ", url);
    return this.http.get<UnitaDocumentariaDTO>(url).pipe(
      map((response) => this.mapperUnitaDocumentaria.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  verificaFirmatario(id: string): Observable<boolean> {
    const url = this.urlUnitaDocumentaria + id + "/firmatario-settore";
    console.log("[DocumentoServiceComponent][getUnitaDocumentaria] url: ", url);
    return this.http.get<boolean>(url).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  getVersioniDocumento(idDocumento: string): Observable<DocumentoVO[]> {
    const url = this.urlDocumento + idDocumento + "/versioni-documento";
    console.log("[DocumentoServiceComponent][getVersioniDocumento] url: ", url);
    return this.http.get<DocumentoDTO[]>(url).pipe(
      map((response) => this.mapperDocumento.convertListDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  getDocumento(idDocumento: string): Observable<DocumentoVO> {
    const url = this.urlDocumento + idDocumento;
    console.log("[DocumentoServiceComponent][getDocumento] url: ", url);
    return this.http.get<DocumentoDTO>(url).pipe(
      map((response) => this.mapperDocumento.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  eliminaUnitaDocumentaria(id: string): Observable<BaseResponseVO> {
    console.log("[DocumentoServiceComponent][eliminaUnitaDocumentaria]");
    return this.http
      .delete<BaseResponseDTO>(this.urlUnitaDocumentaria + id)
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError((err) => {
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  bloccaSbloccaUnitaDocumentaria(
    id: string,
    operazione: string
  ): Observable<BaseResponseVO> {
    console.log("[DocumentoServiceComponent][bloccaSbloccaUnitaDocumentaria]");

    return this.http
      .put<BaseResponseDTO>(
        this.urlUnitaDocumentaria + id + "/" + operazione,
        ""
      )
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  chiudiUnitaDocumentaria(
    id: string,
    soloControlli: boolean
  ): Observable<BaseResponseVO> {
    console.log("[DocumentoServiceComponent][chiudiUnitaDocumentaria]");
    const params = new HttpParams().set(
      "soloControlli",
      soloControlli.toString()
    );
    return this.http
      .put<BaseResponseDTO>(this.urlUnitaDocumentaria + id + "/chiudi", null, {
        params: params,
      })
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  repertoriaUnitaDocumentaria(
    id: string,
    response: DatiReportorioManualiVO
  ): Observable<BaseResponseVO> {
    console.log("[DocumentoServiceComponent][repertoriaUnitaDocumentaria]");
    return this.http
      .put<BaseResponseDTO>(
        this.urlUnitaDocumentaria + id + "/repertoria",
        this.mapperDatiRepertorioManuali.convertVoToDto(response)
      )
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  repertoriaEsternoUnitaDocumentaria(
    id: string,
    datiRepertorio: DatiReportorioManualiVO
  ): Observable<BaseResponseVO> {
    const datiRepertorioDTO: DatiReportorioDTO = this.mapperDatiRepertorio.convertVoToDto(
      datiRepertorio
    );
    // let params = new HttpParams()
    //   .set("numero", datiRepertorioDTO.numero)
    //   .set("anno", datiRepertorioDTO.anno);

    // if (datiRepertorioDTO.mese) {
    //   params = params.append("mese", datiRepertorioDTO.mese.toString());
    // }

    console.log("[DocumentoServiceComponent][repertoriaUnitaDocumentaria]");
    return this.http
      .put<BaseResponseDTO>(
        this.urlUnitaDocumentaria + id + "/repertoria-esterno",
        datiRepertorioDTO
        // { params: params }
      )
      .pipe(
        map((response: BaseResponseDTO) =>
          this.mapperBaseResponse.convertDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  modificaUnitaDocumentaria(
    id: string,
    modificaUd: ModificaUdRequestDTO
  ): Observable<ModificaUdRequestDTO> {
    console.log(
      "[DocumentoServiceComponent][modificaUnitaDocumentaria] id: ",
      id,
      " datiinPost: ",
      modificaUd
    );

    return this.http
      .put<ModificaUdRequestDTO>(this.urlUnitaDocumentaria + id, modificaUd)
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  completaBozzaUnitaDocumentaria(
    id: string,
    completaBozzaUd: CompletaBozzaRequestDTO
  ): Observable<CompletaBozzaRequestDTO> {
    console.log(
      "[DocumentoServiceComponent][completaBozzaUnitaDocumentaria] id: ",
      id,
      " datiinPost: ",
      completaBozzaUd
    );

    return this.http
      .put<CompletaBozzaRequestDTO>(
        this.urlUnitaDocumentaria + id + "/completa-bozza",
        completaBozzaUd
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  modificaTempiUnitaDocumentaria(
    id: string,
    modificaTempi: TempiConservazioneDTO
  ): Observable<TempiConservazioneDTO> {
    console.log(
      "[DocumentoServiceComponent][modificaTempiUnitaDocumentaria] id: ",
      id,
      " datiinPost: ",
      modificaTempi
    );

    return this.http
      .put<TempiConservazioneDTO>(
        this.urlUnitaDocumentaria + id + "/modifica-tempi-ud",
        modificaTempi
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  ricercaSemplice(
    filtro: string,
    idDaScartare: string,
    paginazione: PaginazioneVO,
    ordinamento: OrdinamentoVO
  ): Observable<ResultListVO<UnitaDocumentariaVO>> {
    const url = this.urlUnitaDocumentaria + "ricerca";
    const params = new HttpParams()
      .set("filtro", filtro)
      .set("pageElement", paginazione.size.toString())
      .set("pageNumber", paginazione.pageNumber.toString())
      .set("orderBy", ordinamento.elemento.toString())
      .set("desc", ordinamento.direzione.toString())
      .set("idDaScartare", idDaScartare);
    console.log("[FascicoloServiceComponent][ricercaFascicoli] url", url);
    console.log("[FascicoloServiceComponenrit][cercaFascicoli] filtro", filtro);
    console.log("[FascicoloServiceComponent][ricercaFascicoli] params", params);
    return this.http.get(url, { params: params }).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map(
        (resultList: ResultListDTO<UnitaDocumentariaDTO>) =>
          this.mapperResultListUd.convertDtoToVo(resultList) // creare result list e filtro
      )
    );
  }

  public calcolaDimensioneFile(
    calcolaDimensioniRequest: CalcolaDimensioniRequestVO
  ): Observable<CalcolaDimensioniResponseVO> {
    const calcolaDimensioniRequestDTO = this.mapperCalcolaDimensioniRequest.convertVoToDto(
      calcolaDimensioniRequest
    );
    return this.http
      .post<CalcolaDimensioniResponseDTO>(
        this.urlCalcolaDimensioneDocumento,
        this.mapperCalcolaDimensioniRequest.convertVoToDto(
          calcolaDimensioniRequest
        )
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        }),
        map((response: CalcolaDimensioniResponseDTO) =>
          this.mapperCalcolaDimensioniResponse.convertDtoToVo(response)
        )
      );
  }

  storicoModifiche(
    idUd: string,
    paginazione: PaginazioneVO,
    ordinamento: OrdinamentoVO
  ): Observable<ResultListVO<AttivitaUnitaDocumentariaVO>> {
    console.log("[storicoModifiche]", ordinamento);
    const params = new HttpParams()
      .set("pageElement", paginazione.size.toString())
      .set("pageNumber", paginazione.pageNumber.toString())
      //    .set("orderBy", ordinamento.elemento.toString())
      .set("desc", ordinamento.direzione.toString());
    return this.http
      .get(this.urlUnitaDocumentaria + idUd + "/storico", { params: params })
      .pipe(
        map(
          (resultList: ResultListDTO<AttivitaUnitaDocumentariaDTO>) =>
            this.mapperResultListAttivitaUd.convertDtoToVo(resultList) // creare result list e filtro
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }
}
